import { createFileRoute, Navigate } from '@tanstack/react-router';

export const Route = createFileRoute('/_app/')({
  component: function RedirectToChat() {
    return <Navigate to='/chat' />;
  },
});
